module.exports = __webpack_public_path__ + "6fcab2467cfe2f3cd0085ce74fd4e89c.fbx";